<template>
	<div class="list list--agreements list-agreements">
		<table-list
			:items="agreements"
			:loading="isLoading"
		>
			<template slot="header">
				<span
					:class="`agreements-header-item agreements-header-item--${key}`"
					:key="key"
					v-for="(col, key) in columns"
				>
					<component :is="orderBy[key] ? 'a' : 'span'" @click="sort(key)"> {{ col }}</component>
					<ion-icon :name="query.order == 'asc' ? `caret-up` : `caret-down`" v-if="orderBy[key] && orderBy[key] == query.orderBy"></ion-icon>
				</span>
			</template>

			<template slot="item" slot-scope="{ item }">
				<router-link
					:class="`agreements-item agreements-item--${key} agreements-item--${item['status']}`"
					:key="`item_${key}`"
					:to="{ name: 'agreement', params: { agreementId: item.agreementId, locationId, } }"
					v-for="(col, key) in columns"
					v-html="transform(key, get(item, key))"
				>
				</router-link>
			</template>

		</table-list>
	</div>
</template>

<script>
import { format, parseISO, formatDistanceToNow, formatDistanceToNowStrict } from 'date-fns'
import { get } from 'lodash'

import TableList from '@/components/TableList'
import { AgreementStatus } from '@/lib/enums'

export default {
	name: 'ListAgreements',
	components: {
		TableList,
	},
	props: {
		agreements: {
			type: Array,
			default: () =>([]),
		},
	},
	data: () => ({
		columns: {
			title: 'Name',
			dateCreated: 'Created',
			dateModified: 'Modified',
			status: 'Status',
			// profileName: 'Name',
			// email: 'Email',
			// agreements: 'Client',
			// dateLogin: 'Last Login',
			// status: 'Status',
		},
		order: 'asc',
	}),
	computed: {
		isLoading() {
			return this.$store.getters['misc/loading']
		},
		query() {
			return this.$route.query
		},
		orderBy() {
			let orderBy = {
				// nameEmail: 'firstName',
				// dateCreated: 'dateCreated',
				// organization: 'organization.name',
				// 'settings.salesforceId': 'salesforceId',
				// dateLogin: 'dateLogin',
				// status: 'status',
			}

			return orderBy
		},
		locationId() {
			return this.$route.params.locationId
		},
	},
	methods: {
		transform(key, value) {
			switch(key) {
				case 'dateCreated':
				case 'dateModified':
					try {
						value = `${format(parseISO(value), 'PPp')}`
					} catch (error) {
						try {
							value = `${format(value, 'PPp')}`
						} catch (error) {
							console.warn(error)
						}
					}
					return value
				case 'status':
					return AgreementStatus[value]
			}
			return value
		},
		sort(key) {

		},
		get,
	}
}
</script>

<style scoped lang="scss">
.list-agreements {
	::v-deep .table-list {
		&__item,
		&__header {
			border-bottom: 1px solid modules.color_('border', 'light');
			display: grid;
			grid-template-columns:  repeat(3, minmax(100px, 1fr)) 0.75fr;

			@include modules.media-query('phone') {
				grid-template-columns: minmax(50%, 1fr) minmax(50%, 1fr);
			}
		}

		.list-agreements__app-list {
			list-style-type: none;
			margin: 0;
			padding: 0;
		}
	}

	.agreements-header-item {
		@include modules.fontSize(14px);
		align-items: center;
		display: flex;
		font-weight: 600;
		padding: 1em 1.5em;

		@include modules.media-query('phone') {
			padding: 0.5em 1em;
		}
	}

	.agreements-item {
		color: modules.color_('text', 'dark');
		font-weight: 500;
		overflow-wrap: break-word;
		padding: 1.5em;
		text-decoration: none;

		@include modules.media-query('phone') {
			@include modules.fontSize(15px);
			padding: 0.5em 1em;
		}

		&--pending {
			&.agreements-item--status {
				color: modules.color_('alert', 'warn');
			}
		}

		&--removed {
			opacity: 0.7;

			&.agreements-item--status {
				color: modules.color_('alert', 'error')
			}
		}
	}
}
</style>
